<template>
    <div>
        <pageheading/>
        <div class="uk-padding">
            <div class="uk-container">
                <div>
                    <div uk-grid>
                        <div class="uk-width-1-3@m">
                            <img src="../assets/bhm_bg.jpg" alt="">
                        </div>
                        <div class="uk-width-2-3@m">
                            <div style="margin-top: 5%">
                                <router-link to="/college_bmh" class="upLink">College of Business and Management</router-link>
                                <p>
                                    The College of Business and Management prides itself in preparing men and women
                                    based on Christian principles for positions in businesses and to nurture enterprising students to start their own businesses.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div>
                    <div uk-grid>
                        <div class="uk-width-1-3@m">
                            <img src="../assets/cel_bg.jpg" alt="">
                        </div>
                        <div class="uk-width-2-3@m">
                            <div style="margin-top: 5%">
                                <router-link to="/college_el" class="upLink">College of Education & Leadership</router-link>
                                <p>
                                    In choosing the College of Education and Leadership, students can expect to be provided
                                    with quality Christian education. Members of faculty are competent, committed and good
                                    examples of Christian character and professionalism.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div>
                    <div uk-grid>
                        <div class="uk-width-1-3@m">
                            <img src="../assets/hubbs_bg.jpg" alt="">
                        </div>
                        <div class="uk-width-2-3@m">
                            <div style="margin-top: 5%">
                                <router-link to="/college_hubbs" class="upLink">College of Humanities, Behavioural and Social Sciences</router-link>
                                <p>
                                    HUBSS brings to you the experience of transformation, community, and development.
                                    Most, if not all, of you know exactly what you want to study and plan to remain focused on your avocation.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div>
                    <div uk-grid>
                        <div class="uk-width-1-3@m">
                            <img src="../assets/cnas_bg.jpg" alt="">
                        </div>
                        <div class="uk-width-2-3@m">
                            <div style="margin-top: 5%">
                                <router-link to="/college_cnasahn" class="upLink">College of Natural & Applied Science, Allied Health & Nursing</router-link>
                                <p>
                                    You will find that the College offers exciting opportunities for students to pursue meaningful careers
                                    that will propel them into the world of innovation and evolving sciences, health care, and technology.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>



                <div>
                    <div uk-grid>
                        <div class="uk-width-1-3@m">
                            <img src="../assets/srt_bg.jpg" alt="">
                        </div>
                        <div class="uk-width-2-3@m">
                            <div style="margin-top: 5%">
                                <router-link to="/college_srt" class="upLink">School of Religion & Theology</router-link>
                                <p>
                                    The School of Religion and Theology envisions itself as a major player in the “education
                                    and training of Pastor, Evangelists, Bible Workers, church leaders…” for the Seventh-day
                                    Adventist Church in Jamaica, the Caribbean region, and the world at large.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pageheading from "../components/shared/pageheading";
    export default {
        name: "CollegeAndSchools",
        components: {Pageheading}
    }
</script>

<style scoped>
    .upLink{
        font-size: x-large;
        font-weight: bold;
        color: #033860;
    }
    @media screen and (max-width:600px){


        .upLink{
            font-size: 1.1em !important;
        }
        p,li{
            font-size: 0.8em !important;
        }
        /*img{*/
        /*    height: 40px !important;*/
        /*}*/

    }
</style>
